// src/pages/Sensor/components/SensorPrice.tsx

import { Button } from '@mui/material'
import { useEffect, useState } from 'react'

import { SensorId } from '@/types/domain'

import { HStack, KTextField } from '../../../components'
import { usePriceApi, usePricePool } from '../../../hooks'

type Props = {
  sensorId: SensorId
  unit?: string
}

export const SensorPrice = ({ sensorId, unit = '€' }: Props) => {
  const pricePool = usePricePool()
  const { save: savePrice, update: updatePrice } = usePriceApi()

  const [priceForYear, setPriceForYear] = useState(0)
  const [price, setPrice] = useState(0)

  const [newPrice, setNewPrice] = useState(true)
  const [entityId, setEntityId] = useState(null)

  useEffect(() => {
    const pRecord = pricePool.find(f => f.sensor_id === sensorId)

    if (pRecord) {
      const { entity_id, price, price_for_year } = pRecord

      setEntityId(entity_id)
      setPrice(price)
      setPriceForYear(price_for_year)

      setNewPrice(false)
    } else {
      setNewPrice(true)
    }
  }, [pricePool, sensorId])

  const handleSubmit = actions => {
    switch (actions) {
      case 'save':
        savePrice({
          entity_id: Number(entityId),
          sensor_id: Number(sensorId),
          price_for_year: Number(priceForYear),
          price: Number(price),
        })
        break
      case 'update':
        updatePrice({
          entity_id: Number(entityId),
          sensor_id: Number(sensorId),
          price_for_year: Number(priceForYear),
          price: Number(price),
        })
        break

      default:
        break
    }
  }

  const onChangePrice = event => setPrice(event.target.value)
  const onChangeFixCost = event => setPriceForYear(event.target.value)
  const onSubmit = () => handleSubmit(newPrice ? 'save' : 'update')

  return (
    <HStack sx={{ width: 1 }}>
      <KTextField
        label={'Kosten'}
        onChange={onChangePrice}
        unit={unit}
        value={price}
      />

      <KTextField
        label={'Fixkosten pro Jahr'}
        onChange={onChangeFixCost}
        unit={unit}
        value={priceForYear}
      />

      <Button onClick={onSubmit}>Aktualisieren</Button>
    </HStack>
  )
}
